<script>
    import Vue from 'vue';
    import { Input } from 'element-ui';

    Vue.use(Input);
    
    export default {
        props: {
            ...Input.props,
            
            type: {
                type: String,
                default: 'textarea'
            },

            removeWordSpaces: {
                type: Boolean,
                default: false
            },

            maxChars: {
                type: Number,
                default: 0
            },

            name: {
                type: String,
                default: ''
            },

            id: {
                type: String,
                default: ''
            },

            placeholder: {
                type: String,
                default: ''
            },

            value: {
                type: String,
                default: ''
            }
        },

        computed: {
            totalChars() {
                return this.value ? this.value.length : 0;
            },

            totalCharsClass() {
                return {
                    'text-warning': this.isOverNinetyPercent() && this.totalChars < this.maxChars,
                    'text-danger': this.totalChars >= this.maxChars
                };
            },

            maxCharsClass() {
                return {'text-danger': this.totalChars >= this.maxChars};
            }
        },

        methods: {
            isOverNinetyPercent() {
                return this.totalChars >= Math.ceil(0.9 * this.maxChars);
            },

            valueChanged(newValue) {
                this.$emit('input', newValue);
            },

            onInput(value) {
                if (
                    this.removeWordSpaces 
                    && value[value.length - 1] === " " 
                    && value[value.length - 2] === " "
                ) {

                    value = value.slice(0, value.length - 2);
                }

                this.$emit('input', value);
            }
        }
    }
</script>

<template>
    <div class="relative">
        <el-input
            v-bind="$props"
            :type="type"
            :value="value"
            :maxlength="maxChars"
            :placeholder="placeholder"
            :id="id"
            @input="onInput($event)"
            @blur="$emit('blur', $event)">
        </el-input>
        
        <div class="el-input__char-count">
            <span :class="totalCharsClass">{{ totalChars }}</span> / <span :class="maxCharsClass">{{ maxChars }}</span>
        </div>
    </div>
</template>

